var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-1-1h582v402H-1z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F44336",
    d: "M42.142 92.556 3.704 54.118c-3.412-3.42-3.412-8.76 0-12.17l38.438-38.44c3.42-3.42 8.759-3.42 12.17 0l38.439 38.44c3.42 3.41 3.42 8.75 0 12.17L54.313 92.556c-3.412 3.412-8.968 3.412-12.17 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M43.001 66.714c0-.643.209-1.277.426-1.919.208-.642.642-1.068 1.067-1.493a4.484 4.484 0 0 1 1.71-1.068c.634-.217 1.277-.434 2.136-.434.85 0 1.493.217 2.135.434a4.515 4.515 0 0 1 1.702 1.068c.434.425.86.85 1.068 1.493.217.642.434 1.276.434 1.919 0 .642-.217 1.284-.434 1.927-.209.633-.634 1.067-1.068 1.493a4.73 4.73 0 0 1-1.702 1.067c-.642.209-1.284.426-2.135.426-.86 0-1.502-.217-2.136-.426-.642-.216-1.067-.642-1.71-1.067-.425-.426-.859-.86-1.067-1.493-.217-.643-.426-1.068-.426-1.927zm8.968-9.819h-7.691L43.21 24.647h9.826L51.97 56.895z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusError);
export default __webpack_public_path__ + "static/media/status-error.7d4c00bd68f966d3c7e496edfcc7f2bb.svg";
export { ForwardRef as ReactComponent };